import { render } from "./BankList.vue?vue&type=template&id=38fbb7ff&scoped=true"
import script from "./BankList.vue?vue&type=script&lang=js"
export * from "./BankList.vue?vue&type=script&lang=js"

import "./BankList.vue?vue&type=style&index=0&id=38fbb7ff&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fbb7ff"]])

export default __exports__